module.exports = __webpack_public_path__ + "static/media/iconmonstr-venmo-5.a10dc9c8.svg";